// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__BirKV","modal":"Modal_modal__k80VY","closeButton":"Modal_closeButton__ThMnz"};